/**
 * Merges multiple refs (callback refs and/or RefObject) into one.
 * @example
 *   const combinedRef = mergeRefs(ref1, ref2);
 *   return <input ref={combinedRef} />;
 */
export function mergeRefs<T>(
  ...refs: (React.Ref<T> | undefined | null)[]
): React.RefCallback<T> {
  return (node: T | null) => {
    for (const ref of refs) {
      if (typeof ref === "function") {
        ref(node);
      } else if (ref && typeof ref === "object") {
        (ref as React.MutableRefObject<T | null>).current = node;
      }
    }
  };
}
